import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions } from './index';
import { UserRole } from '../auth';

export type UserCreateData = AnyObject

export type UserCreateResponse = UserCreateData

export interface UserCreateBody {
  email: string;
  role: UserRole;
  yearBirth: number | null;
  zipCode: string | null;
  name: string;
  phone: string | null;
  countryId: number | null;
  photoId: string | null;
  description: string | null;
  categoryId: string | null;
  subCategoryId: string | null;
}

export const userCreate = (payload: UserCreateBody): Action<UserCreateBody> => ({
  type: actions.userCreateTrigger.toString(),
  payload,
});

export const userCreateClear = (): Action => ({
  type: actions.userCreateClear.toString(),
});

export const userCreateErrorClear = (): Action => ({
  type: actions.userCreateErrorReset.toString(),
});

export function* userCreateRequestSaga({ payload }: Action<UserCreateBody>) {
  yield put({
    type: actions.userCreateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.userCreateError.toString(),
      payload: {
        message: 'UserCreate: Parameters not passed.',
      },
    });

    return;
  }

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/users?site=${
      (
        (payload.role === 'admin' || payload.role === 'root')
          ? 'admin_panel' : 'user_portal')
    }`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<UserCreateData, UserCreateResponse>(
    response,
    actions.userCreateSuccess.toString(),
    actions.userCreateError.toString(),
    false,
    (userCreateData) => userCreateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.userCreateTrigger.toString(),
    defaultProcessingSaga(
      userCreateRequestSaga,
      {
        error: actions.userCreateError.toString(),
        locationCancel: actions.userCreateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.userCreateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.userCreateClear.toString(),
    // });
  });

  yield takeLatest(actions.userCreateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.userCreateErrorReset.toString(),
    });
  });
}
